exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4ce1f9bc] .error-body div {\n  margin: 0;\n  margin-top: 20px;\n  padding: 10px;\n}\n.rate-groups[data-v-4ce1f9bc]  .md-card {\n  margin-bottom: 0;\n}\n", ""]);

// exports
